import type { FunctionComponent } from 'react';

import type { FlexboxProps } from './types';

export const Flexbox: FunctionComponent<FlexboxProps> = ({
  direction = 'row',
  wrap = 'nowrap',
  justify = 'start',
  items = 'stretch',
  alignContent = 'stretch',
  className = '',
  children,
  ...props
}) => {
  const flexClasses = `flex-${direction} ${wrap !== 'nowrap' ? `flex-${wrap}` : ''} ${justify !== 'start' ? `justify-${justify}` : ''} ${items !== 'stretch' ? `items-${items}` : ''} ${alignContent !== 'stretch' ? `content-${alignContent}` : ''}`;

  return (
    <div className={`flex ${flexClasses} ${className}`} {...props}>
      {children}
    </div>
  );
};
